const Form051EN = {
    stepName: {
        importantNotes: "Important Notes",
        applicantInformation: "Information of the Applicant",
        confirmation: "Confirmation",
    },
    title: {
        applicantInformation: "Information of the Applicant",
        applicantNotePoints: "Points to Note for Applicant",
        completedApplicant1: `To be completed by the applicant`,
        completedApplicant2: `If you choose to mail the report to you by ordinary post, please write the name and local mailing address of recipient below.`,
        // completedApplicant3: `please write the name and address of recipient below.`,
        completedByEDB: "To be completed by the Education Bureau",
    },
    note: {
        note1: `(1)	If applicant needs to obtain a copy of the audiological report, please complete and submit this form with the necessary supporting documents.`,
        note2: `(2)	Applicants must have reached 18 years of age.`,
        note3: `(3)	Should the applicant fail to provide the required information or if the information provided is inaccurate, the Education Bureau will not be able to provide the requested service.`,
        note4: `(4)	Statement on personal data use: the personal data you provided in this form will be used for verifying the information in relation to this request and other directly related purposes.`,
        note4ii:
            "(4) Personal Information Collection Statement: the personal data provided in this form will be used for verifying the information in relation to your application for obtaining a copy of the audiological report and other directly related purposes.",

        note5: `(5)	For enquiries, please contact the Educational Audiology Service Section (Tel: 3698 3909).`,
        note6: `When a copy of the report is ready for collection, please pass it to me in the method indicated below (please choose`,
        note7: "To applicant:",
        note8: "Attached please find the copy of audiological report of",
        note9: "pages",
        note10: "For enquiries, please contact the Educational Audiology Service Section (Tel: 3698 3909).",
        note11: " one method",
        note12: "):",
    },
    label: {
        identityOption: {
            aboveStudent: {
                aboveStudent1: "I am ",
                aboveStudent2: "A copy of my identity card ",
                aboveStudent3:
                    "is hereby attached for obtaining a copy of my audiological report from the Education Bureau.",
                aboveStudent4: "the above student. ",
            },
            aboveStudentParent: `I am the`,
            aboveStudentGuardian: {
                text1: `I am the `,
                text2: `guardian`,
                text3: ` of the above student (relationship with the student:`,
            },
        },
        relationshipMsg: "relationship",
        aboveStudentParentOption: {
            father: "father",
            mother: "mother",
        },
        aboveStudentParentOptions: {
            aboveStudentFather: `father`,
            aboveStudentMother: `mother`,
        },
        aboveStudentGuardianOption: {
            aboveStudentGuardianFather: `Copy of the identity card of the `,
            aboveStudentGuardianMother: `Copy of other document(s)`,
        },
        aboveStudentGuardianOptions: {
            aboveStudentGuardianFather: `father`,
            aboveStudentGuardianMother: `mother`,
        },
        aboveStudentiDentityCardOptions: {
            informMe: `Inform me to collect it in person`,
            mailMe: `Mail it to me by ordinary post: (Please write the name and local mailing address of the recipient at this page)`,
        },
        identityTypeOption: {
            HKIDCard: "HKID Card",
            passport: "Passport",
            permit: "Exit-Entry Permit for Travelling to and from Hong Kong",
        },
        aboveStudentParentEnd: `of the above student. The following documents are hereby`,
        aboveStudentParentEnd1: {
            text1: "attached to show my parental status for the above student: (1) ",
            text2: "Copy of my identity card,",
            text3: "and (2) ",
            text4: "Copy of the birth certificate or other document(s) of the above student",
            text5: ", for obtaining a copy of the audiological report of the above student from the Education Bureau.",
        },
        aboveStudentGuardianEnd: {
            text1: "The following documents are hereby attached to show my status as the guardian of the above student: (1) ",
            text2: "Copy of my identity card",
            text3: ", and (2) ",
            text4: "Copy of the birth certificate or other document(s) of the above student",
            text5: ", and (3) ",
            text6: "the following documents",
            text7: ", for obtaining of a copy of the audiological report of the above student from the Education Bureau",
        },
        guardianParentChoiceEnd: " of the above student",
        studentEnName: "Name of Student (English)",
        studentCnName: "Name of Student (Chinese)",
        studentNameMsg: "name of student",
        birthDate: "Date of Birth",
        identityNo: "Identity document No.",
        identityNoMsg: "identity document No.",
        issuedDate: `Date around which or period within which the requested report was issued: (If not specified, the latest available version will be provided.)`,
        applicantName: "Name of Student",
        applicantSignature: "Signature of Applicant",
        identityDocumentNo: "Identity Document No.",
        identityDocumentType: "Type of Identity Document",
        identityDocumentMsg: "Identity document No.",
        contactTelephone: "Local Daytime Contact Telephone No.",
        telephoneNumber: "telephone number",
        otherDocument: "document",
        date: "Date",
        name: "Name",
        address: "Local Mailing Address",
        page: "pages",
    },
    errorMsg: {
        englishNameRule:
            "Please input a correct rule (Character type (alphabets only / alpha-numeric / Chinese-only)and special characters which are comma (,), space ( ), plus (+), hash (#), brackets (()) and hyphen (-).)",
        rule: "Please input a correct rule (Character type (alphabets only / alpha-numeric / Chinese-only))",
        telMsg: "Telephone number must be at most 8 digits",
        nameMsg: "Please input a valid name of recipient",
        attachedFile: "Copy of your identity card",
        parentAttachedFile:
            "Copy of your identity card and Copy of the birth certificate or other document(s) of the above student",
        studentRelationship: "relationship with the student",
        otherDocumentTemp: "the information of other document(s)",
        otherDocument: "Copy of other document(s)",
        relationshipRequired: "Please select the relationship",
        guardianChoiceRequired: "Please select document type",
        identityCardChoiceRequired: "Please select the method",
        identityChoiceRequired: "Please select the type of identity",
        name: "Name of Recipient",
        address: "Local Mailing Address",
        identityNo: "Identity Dcoument No.",
    },
};
export default Form051EN;
